<template>
    <!-- Start Copy Right Area  -->
    <div class="copyright-area copyright-style-one">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-8 col-sm-12 col-12">
                    <div class="copyright-left">
                        <ul class="ft-menu link-hover">
                            <li>
                                <router-link to="#">首页</router-link>
                            </li>
                            <li>
                                <router-link to="#">联系我们</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-4 col-sm-12 col-12">
                    <div class="copyright-right text-center text-lg-end">
                        <img class="filing" src="/gab-filing.png" alt="Filing">
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=21021202000368" rel="noreferrer" target="_blank">辽公网安备21021202000368号</a>
                        <p class="copyright-text">© 爱智控制 {{ new Date().getFullYear() }}  辽ICP备16010451号</p>                                                
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Copy Right Area  -->
</template>

<script>
    export default {
        name: 'Copyright'
    }
</script>

<style>
    .copyright-right {
        font-size: 14px;           /* 控制整体字体大小 */
        line-height: 1.4;          /* 保证行高均衡 */
        white-space: nowrap;       /* 保证在一行显示 */
    }

    .copyright-right img.filing {
        width: 16px;               /* 图标宽度 */
        height: auto;              /* 高度比例缩放 */
        vertical-align: middle;    /* 基本垂直居中 */
        position: relative;        /* 开启定位微调 */
        top: -1px;                  /* 上移 1px 精确居中 */
        margin: 0 4px 0 6px;       /* 左右间距（前 6px，后 4px） */
    }

    .filing a[href*="beian.mps.gov.cn"] {
        text-decoration: none;     /* 去掉下划线（可选） */
        color: inherit;            /* 跟随文字颜色 */
    }
</style>